<template>
  <v-container>
    <v-snackbar v-model="snackbar.model" top :color="snackbar.color">
      {{ snackbar.detail }}
    </v-snackbar>
    <CreateEntityDialog ref="entityDialog" @entity-created="onEntityCreated"/>
    <EntityDetail ref="itemDetail" @update-detail="$refs.itemList.load()"/>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-btn class="mb-2" rounded color="success"
                    @click="openEntityDialog">
                    <v-icon>add</v-icon> Add entity
                  </v-btn>
                </v-col>
                <v-col :cols="12" class="entity-list">
                  <EntityList @get-detail="loadDetail" ref="itemList"/>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class'
import EntityService from '@/services/EntityService'
import EntityList from './EntityList'
import EntityDetail from './EntityDetail'
import CreateEntityDialog from '@/components/dialog/CreateEntityDialog'

import { Api } from '@/services/Api'
const EntityModule = namespace('entity')
const BankAccountModule = namespace('bankaccount')

@Component({
  components: {
    EntityList,
    EntityDetail,
    CreateEntityDialog
  }
})
export default class Entity extends Vue {
  snackbar = { model: false }
  submitted = false
  entityId = null
  entities = []

  @Getter rules
  @EntityModule.Getter requiredFields
  @EntityModule.Getter fields
  @BankAccountModule.Action setBankOptions
  @BankAccountModule.Action setAccountTypeOptions
  @Action setPageTitle

  updateOptions (url, callback, prepare) {
    Api().get(url)
      .then(resp => {
        const data = (resp.data.results || resp.data).map(item => {
          if (prepare === undefined) {
            return {
              text: item.name,
              value: item.id
            }
          } else {
            return prepare(item)
          }
        })
        callback(data)
      })
  }

  onEntityCreated (data) {
    if (!data || !data.error) {
      this.$refs.itemList.load()
    } else {
      let detail = ''
      Object.keys(data.error).map(k => {
        detail += `${k}: ${data.error[k]} `
      })
      this.snackbar = {
        model: true,
        detail: detail,
        color: data.error === undefined ? 'success' : 'error'
      }
    }
  }

  loadDetail (item) {
    this.$nextTick(() => {
      this.$refs.itemDetail.load(item)
    })
  }

  loadList () {
    EntityService.list_type()
      .then(resp => {
        this.entities = this.fields[9].items = (resp.data.results || resp.data).map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
        this.requiredFields[3].items = Object.assign([], this.fields[9].items)
      })
  }

  mounted () {
    this.setPageTitle('Entity')
    this.updateOptions('/cashbook/bank/', this.setBankOptions)
    this.updateOptions('/cashbook/bank-account-type/', this.setAccountTypeOptions)
    this.loadList()
  }

  openEntityDialog () {
    this.$refs.entityDialog.open()
  }
}
</script>

<style lang="scss" scoped>
i.fa, i.far { font-size: 20px !important; }
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.border-left-1 {
  border-left: 1px solid #ccc;
}
.business-tabs .v-tabs-bar {
  height: 0;
  margin-top: -16px;
}
.menu-text-field.v-text-field--outlined {
  legend { width: 0 !important; }
  .v-label--active { left: -31px !important; padding: 0 4px; }
  .theme--light.v-label { background-color: #fff; }
  theme--dark.v-label { background-color: #424242; }
}

.entity-list {
  transition: width .3s, max-width .3s !important;
}
</style>
